<div class="modal">
    <div class="modal__body modal__body">
        <i class="fal fa-times modal__close"
           (click)="close(null)"
           data-test-id="closeNoteDialogBtn"></i>
        <h1 class="h2">{{data.heading}}</h1>
        <div class="vert-0050">
            <app-create-note [targetType]="data.targetType"
                             [noteType]="data.noteType"
                             [targetId]="data.targetId"
                             (noteAdded)="noteAdded($event)"
                             class="modal__padding mb-0100 d-block"></app-create-note>
            <app-view-notes *ngIf="data.hideNotes == false"
                            [notes]="notes"
                            [targetType]="data.targetType"
                            [targetId]="data.targetId"></app-view-notes>
        </div>
    </div>
</div>
